import { render } from "./SuccessStories.vue?vue&type=template&id=49ac0c9d&scoped=true&ts=true"
import script from "./SuccessStories.vue?vue&type=script&lang=ts"
export * from "./SuccessStories.vue?vue&type=script&lang=ts"

import "./SuccessStories.vue?vue&type=style&index=0&id=49ac0c9d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ac0c9d"]])

export default __exports__